module.exports = __webpack_public_path__ + "img/info.541dc1c0.svg";